<template>
  <div class="page-content">
    <page-template
      ref="cashier"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      @searchReset="searchReset"
    ></page-template>
  </div>
</template>
<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import userPower from '@/mixin/userPower'

export default {
  mixins: [userPower],
  components: {
    pageTemplate
  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: "收银员编码/姓名",
            type: "input",
            prop: "cashierName",
            ifFuzzy: true,
            placeholder: "请输入收银员编码/姓名"
          }
        ],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span: 12,
            // isHasAllShop: true,//添加‘全部门店’字段
            isHasAll: true,//下拉选择添加‘总部’字段
            change: this.getCashierChange,
            url: api.system.seStore
          },
          {
            label: '收银员',
            type: 'select',
            prop: 'cashierId',
            data: [],
            span: 12,
            // url: api.system.account,
            //param: {type: 40}
          },
          // {
          //   label: "收银员名称",
          //   type: "input",
          //   prop: "cashierName",
          //   ifFuzzy: true,
          //   placeholder: "收银员姓名"
          // },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: "查询",
          code: 'query',
        },
        {
          label: "打印",
          code: 'print',
        },
        {
          label: "导出",
          code: 'export',
          callback: this.exportExcelData
        },
        {
          label: "添加",
          code: 'insert',
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {label: "门店名称", prop: "storeName", width: "190", align: "center"},
          // {
          //   label: "门店编码",
          //   prop: "storeCode",
          //   width: "120",
          //   align: "center"
          // },
          {
            label: '收银员工号',
            prop: 'cashierCode',
            width: '150',
            align: 'center'
          },
          {label: "收银员姓名", prop: "cashierName", width: "120", align: "center"},
          {
            label: '上班时间',
            prop: 'createDttm',
            width: '150',
            align: 'center'
          },
          {
            label: '对账时间',
            prop: 'lastModifyDttm',
            width: '150',
            align: 'center'
          },
          // {
          //   label: '首笔交易时间',
          //   prop: 'firstDttm',
          //   width: '150',
          //   align: 'center'
          // },
          // {
          //   label: "末笔交易时间",
          //   prop: "endDttm",
          //   width: "150",
          //   align: "center",
          // },
          {
            label: "交易金额",
            prop: "totalAmount",
            width: "150",
            align: "center",
          },
          {
            label: "现金交易金额",
            prop: "cashAmount",
            width: "120",
            align: "center",
          },
          // {
          //   label: "状态",
          //   prop: "status",
          //   width: "120",
          //   align: "center",
          //   enumData: this.$utils.getCacheStatus("sysHandoverRecord.status")
          // },
          // {
          //   label: "备注",
          //   prop: "remarks",
          //   width: "120",
          //   align: "center",
          // },
        ],
        param: {
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
        url: api.system.handoverRecord
      },
    };
  },
  created() {
    this.setStore(this.searchOptions.complex);
    this.getCashier()
  },
  methods: {
    // 重置
    searchReset() {
      let userInfo = this.$utils.getSysUser();
      if (!userInfo.storeId) {
        this.searchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = []
      }
    },
    getCashier() {
      let userInfo = this.$utils.getSysUser();
      if (userInfo.storeId) {
        this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: userInfo.storeId}).then(data => {
          if (data.code === 200) {
            this.searchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          }
        })
      }
    },
    getCashierChange(form) {
      form.cashierId = '';
      this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.searchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
        }
      });
    },
    exportExcelData() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs["cashier"].$refs['tableTemp'].searchParam;
      this.$axios.PostBlob(api.system.handoverRecordExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '收银员交接班_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/retail/query/Cashier.vue